import {
    AppBar, Button, Card, CardContent, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl,
    FormControlLabel, FormGroup, Grid2 as Grid, LinearProgress, Paper, Step, StepLabel, Stepper, Tab, Tabs, Typography, CardActions, Divider, Tooltip, TextareaAutosize,
    Fade, Box, InputLabel, Grow, IconButton, ImageList, ImageListItem
} from '@mui/material';
import Slide from '@mui/material/Slide';
import { SlideProps } from '@mui/material/Slide';
import { styled } from '@mui/material/styles';
// import { TransitionProps } from "@material-ui/core/transitions/transition";
// import { SlideProps  } from '@material-ui/core/transitions';

import classNames from 'classnames';
import * as React from "react";
import Dropzone from 'react-dropzone';
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import Select from "react-select";
import { AjaxError } from "rxjs/ajax";
import request from 'superagent';
import { v4 as uuidv4 } from "uuid";
import idssStyle from "../../Configuration/SharedStyling";
import { genericMapStateToProps, IGenericUserProps } from "../../DataClasses/GenericUser";
import { ISubmissionAttestationFlags, ICurrentSubAuths, ISubmissionHomePayload, ISubmissionHomeText, ISubmissionUserPayload, IUploadSection, IValidationResponsePayload, SubmissionActionTypes, IUserAction, ValidationStatusTypes } from "../../DataClasses/SubmissionData";
import { AllowableFileTypes, AllowableFileTypesText, AuditLockButtonMainText, AuditLockButtonTitle, AuditLockButtonUndoMainText, AuditLockButtonUndoTitle, MarkFinalButtonMainText, MarkFinalButtonMainTextUndo, MarkFinalButtonTitle, MarkFinalButtonTitleUndo, PlanLockButtonMainText, PlanLockButtonMainTextUndo, PlanLockButtonTitle, PlanLockButtonTitleUndo, ProductTranslator, AuditLockNoActionText, MarkFinalNoActionText, AttestationButtonMainText, AttestationButtonTitle, AttestationButtonMainTextUndo, AttestationButtonTitleUndo, AttestationNoActionText, ClearMeasureButtonTitle, ClearMeasureButtonMainText } from '../../Utilities/ProductTypeTranslation';
import * as Renderings from "../Pages/Subcomponents/SubmissionHome/SubmissionHome.Renderings";
import * as AllDownloadsTab from "../Pages/Subcomponents/SubmissionHome/SubmissionHome.AllDownloads";
import AuditReviewToolViewTab from "../Pages/Subcomponents/SubmissionHome/SubmissionHome.AuditReviewTool";
import AttestationSteps from "../Pages/Subcomponents/SubmissionHome/SubmissionHome.AttestationSteps";
import ExceptionSerivce from '../Services/ExceptionService';
import SubmissionsService from '../Services/SubmissionsService';
import UserManagerService from "../Services/UserManagerService";
import ErrorDialog from '../Shared/ErrorDialog';
import LoadingDisplay from "../Shared/Loading";
import SharedMaterialReactTable, { ISharedTableColumn } from "../Shared/MaterialReactTable";
import { IFilesUploadReportPayload } from "../../DataClasses/ReportData";
import success from '../../Images/CheckMarkCircle.png';
import * as AuthorizationPolicies from "../../Configuration/AuthorizationPolicies";
import { InsertDriveFile, AddCircle, Delete } from "@mui/icons-material";
import { Fab } from '@mui/material';
import SharedUtility from "../../Utilities/SharedUtility";
import {
    VIEW_ART, UPLOAD_DOCUMENT_HEDIS, UPLOAD_DOCUMENT_NONHEDIS, AUDIT_LOCK, UNLOCK_AUDIT_LOCK, PLAN_LOCK, UNLOCK_PLAN_LOCK, MARK_FINAL_HEDIS, SUBMISSION_GENERIC_ADMIN,
    MARK_FINAL_CAHPS, MARK_FINAL_HOS, ASSIGN_AUDIT_DESIGNATION, SIGN_ATTESTATION_HEDIS, SIGN_ATTESTATION_HOS, DOWNLOAD_RESULTS_HEDIS, DOWNLOAD_RESULTS_CAHPS, DOWNLOAD_RESULTS_HOS, MANAGE_HEDIS_USER,
    MANAGE_PUBLIC_REPORTING, SUB_ID, VIEW_DOWNLOAD_ERRORS_HEDIS, VIEW_DOWNLOAD_ERRORS_NONHEDIS, VIEW_RESULTS_REPORTS_HEDIS, HOS_ENABLE_INTERIM_SUBMISSION
} from "../Shared/Constants";
import { MessageType, ValidationMessage, ValidationError, KeyValuePair } from '../../DataClasses/SharedData';
import UserMessage from '../Shared/Message';
import moment from 'moment';
import ReportsService from "../Services/ReportsService";
import { IEvent } from "../../DataClasses/DbData";
import LoadingDataTable from '../Shared/LoadingDataTable';
import ValidationTable from './Subcomponents/SubmissionHome/SubmissionHome.ValidationTable';
import { SeedTime } from "../../Configuration/Setting";
import { Redirect } from "react-router-dom";
import AdministrationService from "../Services/AdministrationService";
import ProcessingDisplay from "../Shared/ProcessingDisplay";
import { withStyles } from '@mui/styles';
import {
    IFileUploadData,
    ISubmissionActivityData,
    IDetailedSubmissionData,
    IVendorMeasureData,
    IAuditorData,
    ISubmissionHomeState,
    IAttestationState,
    IDialogs,
    TabMetadata,
    SUBMISSION_TAB,
    AUDIT_REVIEW_TOOL_TAB,
    AUDITORS_TAB,
    ALL_DOWNLOADS_TAB,
    UPLOAD_HISTORY_TAB,
    CLEAR_ALL_MEASURES,
    ADMIN_TAB,
    TabInfo,
    IMPORT_SUBMISSION_STEP,
    MARK_FINAL_CAHPS_STEP,
    PLAN_LOCK_STEP,
    AUDIT_LOCK_STEP,
    ATTESTATION_HOS_STEP,
    MARK_FINAL_HEDIS_HOS_STEP,
    ATTESTATION_HEDIS_STEP,
    ATTESTATION_CAHPS_STEP,
    COMPLETE_STEP,
    SubmissionStepsHedis,
    SubmissionStepsCahps,
    SubmissionStepsHos
} from "./Subcomponents/SubmissionHome/SubmissionHome.InterfacesAndConstants";
import { getInitialSubmissionHomeState, initializeComponentHome, SetUserActions, setRedirectState } from "./Subcomponents/SubmissionHome/SubmissionHome.Inititialization";
import { firstValueFrom } from 'rxjs';
const Transition = React.forwardRef<unknown, SlideProps>((props, ref) => <Slide direction="up" ref={ref} {...props} />);

// Styled components for MUI v6
const StyledTooltip = styled(({ className, ...props }: any) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .MuiTooltip-tooltip`]: {
        backgroundColor: '#f2f2f2',
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[16],
        fontSize: 11,
        fontStyle: 'oblique'
    },
}));

function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}

// VIEW
class SubmissionHome extends React.Component<IGenericUserProps & RouteComponentProps<{ subId: string, component: string }> & { classes: any }, ISubmissionHomeState> {
    // Table configurations replaced with MaterialReactTable approach
    private getUploadFilesColumns = (): ISharedTableColumn<IFileUploadData>[] => [
        { accessorKey: 'savedName', header: 'Saved Name', enableFiltering: false },
        { accessorKey: 'originalName', header: 'Original Name', enableFiltering: false },
        { accessorKey: 'component', header: 'Component', enableFiltering: true },
        { accessorKey: 'validationStatus', header: 'Validation Status', enableFiltering: true },
        { accessorKey: 'createUser', header: 'Create User', enableFiltering: false },
        { accessorKey: 'createDate', header: 'Create Date', enableFiltering: false }
    ];

    private getSubmissionActivityColumns = (): ISharedTableColumn<ISubmissionActivityData>[] => [
        {
            accessorKey: 'date',
            header: 'Date',
            enableFiltering: false,
            Cell: ({ cell }) => (
                <span>
                    {moment(cell.getValue()).format("YYYY/MM/DD")}
                </span>
            )
        },
        { accessorKey: 'user', header: 'User', enableFiltering: true },
        { accessorKey: 'message', header: 'Message', enableFiltering: false }
    ];

    private getDetailedSubmissionColumns = (): ISharedTableColumn<IDetailedSubmissionData>[] => [
        { accessorKey: 'key', header: 'Key', enableFiltering: true },
        { accessorKey: 'value', header: 'Value', enableFiltering: true }
    ];

    private getVendorMeasureGuidColumns = (): ISharedTableColumn<IVendorMeasureData>[] => [
        { accessorKey: 'measure', header: 'Measure', enableFiltering: true, size: 100 },
        { accessorKey: 'guid', header: 'Guid', enableFiltering: true }
    ];

    private getAuditorColumns = (): ISharedTableColumn<IAuditorData>[] => [
        { accessorKey: 'email', header: 'Email', enableFiltering: false, enableSorting: true, size: 200},
        { accessorKey: 'auditLevel', header: 'Audit Level', enableFiltering: true, enableSorting: true, size: 120 },
        { accessorKey: 'firstName', header: 'First Name', enableFiltering: false, enableSorting: false },
        { accessorKey: 'lastName', header: 'Last Name', enableFiltering: false, enableSorting: false },
        {
            accessorKey: 'actions',
            header: 'Actions',
            enableFiltering: false,
            size: 90,
            Cell: ({ row }) => {
                const tipTxt = `Delete on ${row.original.auditLevel} Level`;
                return (
                    <div>
                        {this.state.userAction.canManageHedisUser && (
                            <StyledTooltip title={tipTxt} aria-label={tipTxt}>
                                <IconButton onClick={() => this.deleteAuditorIconClick(row.original)}>
                                    <Delete />
                                </IconButton>
                            </StyledTooltip>
                        )}
                    </div>
                );
            }
        }
    ];

    constructor(props) {
        super(props);
        this.state = getInitialSubmissionHomeState(props);
    }

    public async componentDidMount() {
        await initializeComponentHome(this);
    }

    private redirectToErrorPage() {
        return <Redirect to='/errorpage' />;
    }

    public render() {
        const { classes } = this.props;

        // Add user check at the beginning of render
        if (!this.props.user || !this.props.user.access_token) {
            return <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
                <Typography variant="h6" color="textSecondary">Loading user...</Typography>
            </Box>
        }

        if (this.state.redirect) {
            return this.redirectToErrorPage();
        }

        if (this.state.isMainTabLoading) {
            return <div className={classes.flexGrow}>
                {Renderings.renderLoadingSkeleton(this.state.currentSubId, this.props.classes)}
            </div>
        }
        else {
            if (!this.state.submissionData.hasSubmissionAccess) {
                return <Box sx={{ mt: 2 }}><UserMessage text={<Typography variant='body2' color='inherit'>Access denied</Typography>} variant={MessageType.Error} /></Box>
            }
            else {
                var steps = SubmissionStepsHedis;
                const isHedis = this.state.submissionData.component.includes("DST") || this.state.submissionData.component.includes("HEDIS");
                if (this.state.submissionData.component.includes("CAHPS")) {
                    steps = SubmissionStepsCahps
                }
                if (this.state.submissionData.component.includes("HOS")) {
                    steps = SubmissionStepsHos
                }

                //  const activeStepNumber = this.state.submissionData.activeStepNumber.toString();
                let stepIndexNumber = this.GetActualStepIndex();
                const tabValue = this.state.currentTabVal;
                const accountOption = this.state.allAccounts.map(m => ({
                    label: m,
                    value: m
                }));
                const accountLevelOption = [{ label: "Submission Level", value: "submission" }, { label: "Organization Level", value: "organization" }];
                const reactSelectStyles = {
                    container: (base, state) => ({
                        ...base,
                        opacity: state.isDisabled ? ".5" : "1",
                        backgroundColor: "transparent",
                        zIndex: "999"
                    })
                };
                var seedTime = 400;
                return (
                    <Box sx={{ flexGrow: 1 }}>
                        <Fade
                            in={!this.state.isMainTabLoading}
                            {...(!this.state.isMainTabLoading
                                ? { timeout: seedTime }
                                : {})}
                        >
                            {Renderings.renderTopDisplayGrid(this.state.submissionData, this.state.currentSubId, this.props.classes)}
                        </Fade>
                        <Fade
                            in={!this.state.isMainTabLoading}
                            {...(!this.state.isMainTabLoading
                                ? { timeout: 2 * seedTime }
                                : {})}
                        >
                            <AppBar position="static">
                                <Tabs value={tabValue} onChange={this.handleTabChange}>
                                    {TabInfo.map((item, i) => {
                                        if ((i === AUDIT_REVIEW_TOOL_TAB && (!isHedis || !this.state.userAction.canViewArt || this.state.submissionData.validationStatus === ValidationStatusTypes.NotRun || this.state.submissionData.validationStatus === ValidationStatusTypes.SchemaError || this.state.submissionData.validationStatus === ValidationStatusTypes.Fatal)) ||
                                            (i === AUDITORS_TAB && (!this.state.userAction.canManageHedisUser || !isHedis || !this.state.submissionData.isAuditRequired)) ||
                                            (i === ALL_DOWNLOADS_TAB && !(this.state.userAction.canDownloadResultHedis && isHedis) && !((this.state.userAction.canDownloadResultCahps || this.state.userAction.canDownloadResultHos) && !isHedis)) ||
                                            (i === ADMIN_TAB && !this.state.isSysAdmin) ||
                                            (i === CLEAR_ALL_MEASURES && (this.state.submissionData.activeStepNumber !== PLAN_LOCK_STEP || !this.state.userAction.canUploadHedis)) ||
                                            (item.HedisOnly && !isHedis)) {
                                            return null;
                                        }
                                        else {
                                            return (<Tab label={item.Label} value={i} key={i} />);
                                        }
                                    })}
                                </Tabs>
                            </AppBar>
                        </Fade>
                        <Fade
                            in={!this.state.isMainTabLoading}
                            {...(!this.state.isMainTabLoading
                                ? { timeout: 3 * seedTime }
                                : {})}
                        >
                            {
                                tabValue === SUBMISSION_TAB ?
                                    <div>
                                        <TabContainer>
                                            <Grid container={true} className={classes.flexGrow} spacing={2}>
                                                <Grid spacing={2} sx={{ pl: 2 }} size={12}>
                                                    {this.state.isGenericActionHappening || (this.state.uploadSection.uploadCompletionPercent === 100 && !this.state.uploadSection.fileProcessingComplete) ?
                                                        <div><LinearProgress /></div> : null}
                                                    <Box sx={{ backgroundColor: 'white', padding: 2, borderRadius: 2 }}>
                                                    <Stepper activeStep={stepIndexNumber}>
                                                        {steps.map((label) => {
                                                            const props = {};
                                                            const labelProps = {};
                                                            if (label.Number === AUDIT_LOCK_STEP && !this.state.submissionData.isAuditRequired) {
                                                                return null;
                                                            }
                                                            else {
                                                                return (
                                                                    <Step key={label.Number} {...props} sx={{ color: '#4F758B' }}>
                                                                        <StepLabel {...labelProps}>{label.Name}</StepLabel>
                                                                    </Step>
                                                                );
                                                            }
                                                        })}
                                                    </Stepper>
                                                    </Box>
                                                </Grid>

                                                <Grid container spacing={2} sx={{ p: 2 }} size={{xs: 12}}>
                                                    {this.renderActiveComponent()}
                                                </Grid>
                                            </Grid>
                                        </TabContainer>
                                    </div>
                                    : tabValue === AUDIT_REVIEW_TOOL_TAB ?
                                        <AuditReviewToolViewTab subId={this.state.currentSubId}
                                            productLine={this.state.submissionData.productLine}
                                            component={this.state.submissionData.component}
                                            specialProject={this.state.submissionData.specialProject}
                                            isReadOnly={!(this.state.submissionData.activeStepNumber === AUDIT_LOCK_STEP && this.state.userAction.canAuditLock)}
                                            canViewResultsReportsHedis={this.state.userAction.canViewResultReportsHedis}
                                            isAuditRequired={this.state.submissionData.isAuditRequired ?? false} />
                                        : tabValue === AUDITORS_TAB ?
                                            <div>
                                                <TabContainer>
                                                    {this.state.userAction.canManageHedisUser ? <>
                                                        <Typography variant='subtitle1' color='primary' sx={{ fontWeight: 'bold', color: '#4F758B' }}>
                                                            Assign User as Submission Auditor
                                                        </Typography>
                                                        <Paper sx={{ p: 2, mb: 2 }}>
                                                            <ErrorDialog
                                                                showError={this.state.errorMsg !== ""}
                                                                errorMsg={this.state.errorMsg}
                                                                buttonHandler={() => this.setState({ errorMsg: "" })}
                                                            />

                                                            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                                                                <Box sx={{ minWidth: 350 }}>
                                                                    <Select
                                                                        styles={reactSelectStyles}
                                                                        options={accountOption}
                                                                        placeholder="Select an account"
                                                                        isMulti={false}
                                                                        value={this.state.selectedAccount}
                                                                        closeMenuOnSelect={false}
                                                                        isSearchable={true}
                                                                        onChange={this.selectedAccountChange.bind(this)}
                                                                    />
                                                                </Box>
                                                                <Box sx={{ minWidth: 200 }}>
                                                                    <Select
                                                                        styles={reactSelectStyles}
                                                                        options={accountLevelOption}
                                                                        placeholder="Select account level"
                                                                        isMulti={false}
                                                                        value={this.state.selectedAccountLevel}
                                                                        closeMenuOnSelect={false}
                                                                        isSearchable={true}
                                                                        onChange={this.selectedAccountLevelChange.bind(this)}
                                                                    />
                                                                </Box>
                                                                <Box>
                                                                    <Button
                                                                        variant='contained'
                                                                        color='secondary'
                                                                        onClick={() => {
                                                                            this.onClickAddAuditor(this.state.selectedAccount.value, this.state.selectedAccountLevel.value)
                                                                        }}
                                                                        startIcon={<AddCircle />}
                                                                        disabled={this.state.selectedAccount === ""}
                                                                    >
                                                                        ASSIGN AUDITOR
                                                                    </Button>
                                                                </Box>
                                                            </Box>
                                                        </Paper>
                                                    </> : null}
                                                    <Paper sx={{ p: 2 }}>
                                                        <SharedMaterialReactTable
                                                            data={this.state.users.map(user => ({
                                                                email: user[0],
                                                                auditLevel: user[1],
                                                                firstName: user[2],
                                                                lastName: user[3],
                                                                actions: user[4]
                                                            }))}
                                                            columns={this.getAuditorColumns()}
                                                            title="Auditors"
                                                            isLoading={this.state.isAuditorTabLoading}
                                                            enablePagination={true}
                                                            enableSorting={true}
                                                            enableFiltering={true}
                                                            enableDownloadCsv={true}
                                                            initialState={{
                                                                pagination: { pageIndex: 0, pageSize: 20 },
                                                            }}
                                                            muiPaginationProps={{
                                                                rowsPerPageOptions: [10, 15, 20, 25, 50, 75, 100, 500, 1000],
                                                            }}
                                                        />
                                                    </Paper>
                                                </TabContainer>
                                            </div>
                                            : tabValue === ALL_DOWNLOADS_TAB ?
                                                this.state.isAllDownloadsTabLoading ?
                                                    <LoadingDisplay size={300} progressText="." />
                                                    :
                                                    <div>
                                                        <TabContainer>
                                                            {isHedis ?
                                                                <FormControl>
                                                                    <FormControlLabel
                                                                        control={<Checkbox
                                                                            checked={this.state.showAllDownloads}
                                                                            onChange={() => this.setState({ showAllDownloads: !this.state.showAllDownloads })}
                                                                            color="primary"
                                                                        />}
                                                                        label="Show All Archived Files"
                                                                    />
                                                                </FormControl>
                                                                : null}
                                                            {AllDownloadsTab.renderAllDownloadsTable(this.state.showAllDownloads ? this.state.allDownloads : this.state.allDownloads.filter(x => !x[4]), this.downloadFile, this.props.classes)}
                                                        </TabContainer>
                                                    </div>

                                                : tabValue === UPLOAD_HISTORY_TAB ?
                                                    <Fade in={true} timeout={SeedTime}>
                                                        <div>
                                                            <TabContainer>
                                                                <SharedMaterialReactTable
                                                                    data={this.state.history.map(item => ({
                                                                        savedName: item[0],
                                                                        originalName: item[1],
                                                                        component: item[2],
                                                                        validationStatus: item[3],
                                                                        createUser: item[4],
                                                                        createDate: item[5]
                                                                    }))}
                                                                    columns={this.getUploadFilesColumns()}
                                                                    title="Uploaded Files"
                                                                    isLoading={this.state.isHistoryTabLoading}
                                                                    enablePagination={true}
                                                                    enableSorting={true}
                                                                    enableFiltering={true}
                                                                    initialState={{
                                                                        pagination: { pageIndex: 0, pageSize: 20 },
                                                                    }}
                                                                    muiPaginationProps={{
                                                                        rowsPerPageOptions: [10, 15, 20, 25, 50, 75, 100, 500, 1000],
                                                                    }}
                                                                    enableDownloadCsv={true}  // Enable CSV download
                                                                />
                                                            </TabContainer>
                                                        </div>
                                                    </Fade>
                                                    : tabValue === CLEAR_ALL_MEASURES ?
                                                        <div>
                                                            <TabContainer>
                                                                <Grid container spacing={3}>
                                                                    <Grid key={1} size={4} className={classes.gridDisplay}>
                                                                        <Card className={classes.card}>
                                                                            <CardContent>
                                                                                <div>
                                                                                    <UserMessage text={<Typography variant='body2' color='inherit'>All previously uploaded files will be cleared and submission will move to import stage.</Typography>} variant={MessageType.Warning} />
                                                                                </div>
                                                                            </CardContent>
                                                                            <CardActions>
                                                                                <Fab disabled={this.state.submissionData.didValidationError && !this.state.userAction.canUploadHedis} variant="extended" color="primary" onClick={() => { this.setState({ dialogStatus: { ...this.state.dialogStatus, clearMeasuresOpen: true } }) }}>
                                                                                    Clear
                                                                                </Fab>
                                                                                <Dialog
                                                                                    open={this.state.dialogStatus.clearMeasuresOpen}
                                                                                    aria-labelledby="alert-dialog-title"
                                                                                    aria-describedby="alert-dialog-description"
                                                                                    TransitionComponent={Transition}
                                                                                >
                                                                                    <DialogTitle id="alert-dialog-title"><Typography className={classes.primaryBlueSmall}>{this.state.dialogStatus.clearMeasuresTitle}</Typography></DialogTitle>
                                                                                    <DialogContent>
                                                                                        <DialogContentText id="alert-dialog-description">
                                                                                            <Typography className={classes.secondaryText}>{this.state.dialogStatus.clearMeasuresText}</Typography>
                                                                                        </DialogContentText>
                                                                                    </DialogContent>
                                                                                    <DialogActions>
                                                                                        <Button onClick={() => { this.setState({ dialogStatus: { ...this.state.dialogStatus, clearMeasuresOpen: false } }) }} className={classes.disabledButton} disabled={this.state.isGenericActionHappening}>
                                                                                            Cancel
                                                                                        </Button>
                                                                                        <Button onClick={() => this.unSubmitFile()} autoFocus disabled={this.state.isGenericActionHappening}>
                                                                                            Continue
                                                                                        </Button>
                                                                                    </DialogActions>
                                                                                </Dialog>
                                                                            </CardActions>
                                                                        </Card>
                                                                    </Grid>
                                                                </Grid>
                                                            </TabContainer>
                                                        </div>
                                                        : tabValue === ADMIN_TAB ?
                                                            <div>
                                                                <TabContainer>
                                                                    <Grid container spacing={3}>
                                                                        <Grid key={1} size={4} className={classes.gridDisplay}>
                                                                            <Card className={classes.card}>
                                                                                <CardContent>
                                                                                    <Typography className={classes.primaryBlue}>
                                                                                        Reprocess submission file
                                                                                    </Typography>
                                                                                </CardContent>
                                                                                <CardActions >
                                                                                    <Button variant='contained' color='primary' aria-label="Reprocess" onClick={() => this.reprocessSubmission()}>Reprocess</Button>
                                                                                </CardActions>
                                                                            </Card>
                                                                        </Grid>
                                                                        <Grid key={2} size={4} sx={{ display: 'flex' }}>
                                                                            {this.state.userAction.canManagePublicReporting ? <>
                                                                                <Card sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '100%' }}>
                                                                                    <CardContent>
                                                                                        <Typography sx={{ color: '#4F758B', fontSize: '1.2em', fontWeight: 'bold' }}>
                                                                                            Manage attestation flags
                                                                                        </Typography>
                                                                                        <FormControl>
                                                                                            <FormGroup>
                                                                                                <FormControlLabel sx={{ mb: 0 }}
                                                                                                    control={
                                                                                                        <Checkbox color="primary"
                                                                                                            checked={this.state.submissionData.isPublicReported === true}
                                                                                                            onChange={(e, checked) => this.handleAttestationFlagChange('PublicReporting', checked)}
                                                                                                        />
                                                                                                    }
                                                                                                    label="Public Reporting"
                                                                                                />
                                                                                                <FormControlLabel sx={{ mb: 0 }}
                                                                                                    control={
                                                                                                        <Checkbox color="primary"
                                                                                                            checked={this.state.submissionData.somc}
                                                                                                            onChange={(e, checked) => this.handleAttestationFlagChange('Somc', checked)}

                                                                                                        />
                                                                                                    }
                                                                                                    label="SOMC"
                                                                                                />
                                                                                            </FormGroup>
                                                                                        </FormControl>
                                                                                    </CardContent>
                                                                                    <CardActions>
                                                                                        <Button variant='contained' color={'primary'} disabled={this.state.isAdminUpdatingAttestFlags} aria-label="Save changes" onClick={() => this.updateSubmissionAttestationFlags()}>Save Changes</Button>
                                                                                        {this.state.isAdminUpdatingAttestFlags && <CircularProgress color="primary" size={20} />}
                                                                                        {this.state.isFlagUpdateSuccessful && <img src={success} height='28' width='28' alt='Flags updated succesfully' />}
                                                                                    </CardActions>
                                                                                </Card>
                                                                            </> : null
                                                                            }
                                                                        </Grid>
                                                                        <Grid key={3} size={6} sx={{ display: 'flex' }}>
                                                                            <Card sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '100%' }}>
                                                                                <CardContent>
                                                                                    {this.state.isSubmissionActivitiesLoading ?
                                                                                        <LoadingDataTable titleText='Submission activities'/>
                                                                                        :
                                                                                        <SharedMaterialReactTable
                                                                                            data={this.state.submissionActivities.map(item => ({
                                                                                                date: item[0],
                                                                                                user: item[1],
                                                                                                message: item[2]
                                                                                            }))}
                                                                                            title='Submission activities'
                                                                                            columns={this.getSubmissionActivityColumns()}
                                                                                            isLoading={this.state.isSubmissionActivitiesLoading}
                                                                                            enablePagination={true}
                                                                                            enableSorting={true}
                                                                                            enableFiltering={true}
                                                                                            initialState={{
                                                                                                pagination: { pageIndex: 0, pageSize: 20 },
                                                                                            }}
                                                                                            muiPaginationProps={{
                                                                                                rowsPerPageOptions: [10, 15, 20, 25, 50, 75, 100, 500, 1000],
                                                                                            }}
                                                                                        />}
                                                                                </CardContent>
                                                                            </Card>
                                                                        </Grid>
                                                                        <Grid key={4} size={6} sx={{ display: 'flex' }}>
                                                                            <Card sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '100%' }}>
                                                                                <CardContent>
                                                                                    {this.state.isDetailedSubmissionDetailLoading ?
                                                                                        <LoadingDataTable titleText='Detailed Submission Detail'/>
                                                                                        :
                                                                                        <SharedMaterialReactTable
                                                                                            data={this.state.detailedSubmissionMeta.map(item => ({
                                                                                                key: item[0],
                                                                                                value: item[1]
                                                                                            }))}
                                                                                            title='Detailed Submission Detail'
                                                                                            columns={this.getDetailedSubmissionColumns()}
                                                                                            isLoading={this.state.isDetailedSubmissionDetailLoading}
                                                                                            enablePagination={true}
                                                                                            enableSorting={true}
                                                                                            enableFiltering={true}
                                                                                            initialState={{
                                                                                                pagination: { pageIndex: 0, pageSize: 20 },
                                                                                            }}
                                                                                            muiPaginationProps={{
                                                                                                rowsPerPageOptions: [10, 15, 20, 25, 50, 75, 100, 500, 1000],
                                                                                            }}
                                                                                        />}
                                                                                </CardContent>
                                                                            </Card>
                                                                        </Grid>
                                                                        <Grid key={5} size={6} sx={{ display: 'flex' }}>
                                                                            <Card sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '100%' }}>
                                                                                <CardContent>
                                                                                    {this.state.isVendorMeasureGuidsLoading ?
                                                                                        <LoadingDataTable titleText='Vendor Measure Guids'/>
                                                                                        :
                                                                                        <SharedMaterialReactTable
                                                                                            data={this.state.vendorMeasureGuids.map(item => ({
                                                                                                measure: item[0],
                                                                                                guid: item[1]
                                                                                            }))}
                                                                                            title='Vendor Measure Guids'
                                                                                            columns={this.getVendorMeasureGuidColumns()}
                                                                                            isLoading={this.state.isVendorMeasureGuidsLoading}
                                                                                            enablePagination={true}
                                                                                            enableSorting={true}
                                                                                            enableFiltering={true}
                                                                                            initialState={{
                                                                                                pagination: { pageIndex: 0, pageSize: 20 },
                                                                                            }}
                                                                                            muiPaginationProps={{
                                                                                                rowsPerPageOptions: [10, 15, 20, 25, 50, 75, 100],
                                                                                            }}
                                                                                        />}
                                                                                </CardContent>
                                                                            </Card>
                                                                        </Grid>
                                                                    </Grid>
                                                                    {/* </Paper> */}
                                                                </TabContainer>
                                                            </div>
                                                            :
                                                            <div>
                                                                <TabContainer>
                                                                    Default
                                                                </TabContainer>
                                                            </div>
                            }
                        </Fade>
                    </Box>
                );
            }
        }
    }

    public handleTabChange = async (event, index: number) => {
        this.setState({ currentTabVal: index });
        await this.RefreshModel(index);
    };

    private GetActualStepIndex(): number {
        var steps = SubmissionStepsHedis;
        if (this.state.submissionData.component.includes("CAHPS")) {
            steps = SubmissionStepsCahps
        }
        if (this.state.submissionData.component.includes("HOS")) {
            steps = SubmissionStepsHos
        }

        let stepIndexNumber = 0;
        if (this.state.submissionData.activeStepNumber !== 0) {
            stepIndexNumber = steps.findIndex(x => x.Number === this.state.submissionData.activeStepNumber);

            //adjust the step index for audit not required subs (skipping audit lock stage)
            if (!this.state.submissionData.isAuditRequired && this.state.submissionData.activeStepNumber >= MARK_FINAL_HEDIS_HOS_STEP) {
                stepIndexNumber--;
            }
        }

        // Always move past the last step - this will make the last step be checked off
        if (stepIndexNumber + 1 === steps.length) {
            stepIndexNumber = stepIndexNumber + 1;
        }
        return stepIndexNumber;
    }

    private async RefreshModel(index) {
        switch (index) {
            case SUBMISSION_TAB:
                await this.getSubmissionSummary(false);
                break;
            case AUDITORS_TAB:
                this.getUserData();
                this.getAccounts();
                break;
            case ADMIN_TAB:
                this.getSubmissionActivities();
                this.getDetailedSubmissionDetails();
                this.getVendorMeasureGuids();
                break;
            case ALL_DOWNLOADS_TAB:
                this.getAllDownloads();
                break;
            case UPLOAD_HISTORY_TAB:
                this.getSubmissionFileHistory();
                break;
        }
    }
    private async getSubmissionActivities() {
        this.setState({ isSubmissionActivitiesLoading: true });
        const retval: IEvent[] | AjaxError = await firstValueFrom(
            ReportsService.GetSubmissionEvents$(this.props.user, this.state.submissionData.subId, this.state.submissionData.component)
        );
        if (retval instanceof AjaxError || !retval) {
            setRedirectState(this);
        } else {
            this.setState({
                submissionActivities: retval.map(item => [
                    item.timestamp,
                    item.user,
                    item.message
                ])
            });
        }
        this.setState({ isSubmissionActivitiesLoading: false });
    }

    private async getDetailedSubmissionDetails() {
        this.setState({ isDetailedSubmissionDetailLoading: true });
        const retval = await firstValueFrom(
            SubmissionsService.GetDetailedSubmission$(this.props.user, this.state.submissionData.subId.toString(), this.state.submissionData.component)
        );
        if (retval instanceof AjaxError || !retval) {
            setRedirectState(this);
        } else {
            this.setState({
                detailedSubmissionMeta: retval.metadatas.map(x => [x.key, x.value])
            });
        }
        this.setState({ isDetailedSubmissionDetailLoading: false });
    }

    private async getVendorMeasureGuids() {
        this.setState({ isVendorMeasureGuidsLoading: true });
        const retval: KeyValuePair[] | AjaxError = await firstValueFrom(
            SubmissionsService.GetVendorMeasureGuids$(this.props.user, this.state.submissionData.vendorId.toString())
        );
        if (retval instanceof AjaxError || !retval) {
            setRedirectState(this);
        } else {
            this.setState({
                vendorMeasureGuids: retval.map(x => [x.key, x.value])
            });
        }
        this.setState({ isVendorMeasureGuidsLoading: false });
    }

    private async GetAllAuthorizedUserActions() {
        return await firstValueFrom(
            UserManagerService.GetAllAuthorizedUserActions$(this.props.user, SUB_ID, this.state.submissionData.subId)
        );
    }

    private async RefreshAuditorsList() {
        const apiCall = SubmissionsService.GetSubmissionAuditors$(this.props.user, this.state.submissionData.orgId, this.state.submissionData.subId);
        const userResponse = await firstValueFrom(apiCall);
        if (userResponse instanceof AjaxError || !userResponse) {
            setRedirectState(this);
        } else {
            const usersData = userResponse.map(item => [
                item.roleUser.email,
                item.roleUser.roleType,
                item.salesforceUser.firstName,
                item.salesforceUser.lastName,
                item.roleUser.email
            ]);
            this.setState({ users: usersData });
        }
    }

    private async deleteAuditorIconClick(auditorData: IAuditorData) {
        try {
            await firstValueFrom(
                SubmissionsService.UpdateAuditor$(this.props.user, this.state.submissionData.orgId, this.state.submissionData.subId, auditorData.email, auditorData.auditLevel, "delete")
            );
        } catch (ex) {
            const error = ex as AjaxError;
            this.setState({ errorMsg: ExceptionSerivce.StandardAjaxExceptionHandler(error) });
        }
        this.RefreshAuditorsList();
    }
    private selectedAccountChange(newValue): void {
        this.setState({ selectedAccount: newValue });
    }
    private selectedAccountLevelChange(newValue): void {
        this.setState({ selectedAccountLevel: newValue });
    }
    public async onClickAddAuditor(userName: string, accountLevel: string) {
        try {
            await firstValueFrom(
                SubmissionsService.UpdateAuditor$(this.props.user, this.state.submissionData.orgId, this.state.submissionData.subId, userName, accountLevel, "add")
            );
        } catch (ex) {
            const error = ex as AjaxError;
            this.setState({ errorMsg: ExceptionSerivce.StandardAjaxExceptionHandler(error) });
        }
        this.setState({ selectedAccount: "", selectedAccountLevel: "" });
        this.RefreshAuditorsList();
    }

    private getUserData = async (): Promise<void> => {
        this.setState({ isAuditorTabLoading: true });
        const apiCall = SubmissionsService.GetSubmissionAuditors$(this.props.user, this.state.submissionData.orgId, this.state.submissionData.subId);
        const userResponse: ISubmissionUserPayload[] | AjaxError = await firstValueFrom(apiCall);
        if (userResponse instanceof AjaxError || !userResponse) {
            setRedirectState(this);
        } else {
            const usersData = userResponse.map(item => [
                item.roleUser.email,
                item.roleUser.roleType,
                item.salesforceUser.firstName,
                item.salesforceUser.lastName,
                item.roleUser.email
            ]);
            this.setState({ users: usersData, isAuditorTabLoading: false });
        }
    }

    private getAccounts = async (): Promise<void> => {
        const apiCall = AdministrationService.GetAllAuditors$(this.props.user);
        const userResponse = await firstValueFrom(apiCall);
        if (userResponse instanceof AjaxError || !userResponse) {
            setRedirectState(this);
        } else {
            this.setState({ allAccounts: userResponse });
        }
    }

    private fetchValidationData = async (sub: ISubmissionHomePayload): Promise<void> => {
        if (sub.activeStepNumber === PLAN_LOCK_STEP || sub.activeStepNumber === MARK_FINAL_CAHPS_STEP || sub.activeStepNumber === ATTESTATION_HOS_STEP) {
            this.setState({ isValidationTableLoading: false });
            const apiCall = SubmissionsService.GetValidationData$(this.props.user, this.state.currentSubId, sub);
            const validations = await firstValueFrom(apiCall);
            if (validations instanceof AjaxError || !validations) {
                setRedirectState(this);
            } else {
                this.setState({ validation: validations, isValidationTableLoading: true});
            }
        }
    }

    private getSubmissionSummary = async (refresh: boolean): Promise<void> => {
        // Add user validation
        if (!this.props.user || !this.props.user.access_token) {
            console.error('User not available for API call');
            setRedirectState(this);
            return;
        }
        if (refresh) {
            this.setState({ isGenericActionHappening: true });
        }
        else if (this.state.submissionData == null) {
            this.setMainTabLoadingState(true);
        }
        const apiCall = SubmissionsService.GetSubmissionSummary$(this.props.user, this.state.currentSubId, this.state.component);
        
        var tmpValidation = {
            submissionId: -1,
            urlString: "",
            headerUrlString: "",
            detailUrlString: "",
            validationText: "",
            validationErrors: []
        };
        //Clear out the validation display.
        this.setState({ validation: tmpValidation });

        const subSummary = await firstValueFrom(apiCall);
        if (subSummary instanceof AjaxError || !subSummary) {
            setRedirectState(this);
        }
        else {
            if (subSummary.hasSubmissionAccess) {
                this.setState({
                    submissionData: subSummary,
                    isOrgAdmin: AuthorizationPolicies.IsAdminForOrg(this.props.user, subSummary.orgId.toString())
                });
            }
            else {
                this.setMainTabLoadingState(false);
            }

            if (refresh) {
                this.setState({ isGenericActionHappening: false });
            }
            else {
                this.setMainTabLoadingState(false);
            }
            if (subSummary.hasSubmissionAccess) {
                this.fetchValidationData(subSummary);
            }
        }
    }

    private setMainTabLoadingState = (loading: boolean) => {
        this.setState({ isMainTabLoading: loading });
    }

    private getSubmissionFileHistory = async (): Promise<void> => {
        this.setState({ isHistoryTabLoading: true });
        const apiCall = SubmissionsService.GetUploadedDocsForSubmission$(this.props.user, this.state.submissionData.subId, this.state.component);
        const subHistory: IFilesUploadReportPayload[] | AjaxError = await firstValueFrom(apiCall);
        if (subHistory instanceof AjaxError || !subHistory) {
            setRedirectState(this);
        } else {
            const historyData = subHistory.map(item => [
                item.savedName,
                item.originalName,
                item.component,
                item.validationStatus,
                item.createUser,
                item.createDate
            ]);
            this.setState({ history: historyData, isHistoryTabLoading: false });
        }
    }

    private getAllDownloads = () => {
        this.setState({ isAllDownloadsTabLoading: true });
        const allDownloadsTableData = this.state.submissionData.submissionDownloads.map(
            item => {
                return [
                    item.displayName,
                    item.uploadDay + " " + item.uploadTime,
                    item.uploadUser,
                    item.key,
                    item.isArchived
                ]
            }
        );

        this.setState({
            allDownloads: allDownloadsTableData,
            isAllDownloadsTabLoading: false
        });
    }

    private downloadFile = async (key: string): Promise<void> => {
        var fileUrl = await this.getDownloadUrl(key);
        window.location.href = fileUrl;
    }

    private getDownloadUrl = async (key: string): Promise<string> => {
        const apiCall = SubmissionsService.GetSubmissionLink$(
            this.props.user,
            this.state.submissionData.subId,
            this.state.component,
            this.state.submissionData.isFileUploaded,
            this.state.submissionData.isFileProcessed,
            this.state.submissionData.activeStepNumber,
            key,
            this.state.submissionData.productLine
        );
        const linkUrl = await firstValueFrom(apiCall);
        return linkUrl;
    }

    private renderActiveComponent() {
        const { classes } = this.props;
        var adjustedStepNumber = this.state.submissionData.activeStepNumber;
        const isCahps = this.state.component.includes("CAHPS");
        const isHOS = this.state.component.includes("HOS");
        const isHedis = this.state.component.includes("HEDIS") || this.state.component.includes("DST");
        const isCahpsOnly = this.state.submissionData.isCahpsOnlySubmission;
        const canPublicReport = this.state.userAction.canManagePublicReporting;
        const canSignHedis = this.state.userAction.canSignAttestationHedis;
        const canReportOrSignHedis = canPublicReport || canSignHedis;
        var lockTitle = "";
        if (isCahps) {
            lockTitle = "Mark Final";
        }
        else if (isHedis) {
            lockTitle = "Plan Lock";
        }
        else if (isHOS) {
            lockTitle = "Continue";
        }

        switch (adjustedStepNumber) {
            case IMPORT_SUBMISSION_STEP:
            case MARK_FINAL_CAHPS_STEP:
            case ATTESTATION_HOS_STEP:
            case PLAN_LOCK_STEP:
                //Note:  Returning a multi part frament rather than a single node, as it very much impacts rendering.
                return <>
                    {(isHedis && this.state.userAction.canUploadHedis) || (!isHedis && this.state.userAction.canUploadNonHedis) ? <>
                        <Grid key={1} size={6} className={classes.gridDisplay}>
                            <Card className={classes.card}>
                                <CardContent>
                                    <Typography className={classes.primaryBlue + " " + classes.marginBottom} >
                                        File Management
                                    </Typography>
                                    {this.state.submissionData.isFileUploadAllowed ?
                                        <div>
                                            {this.state.uploadSection && this.state.uploadSection.uploadValidationMessages && this.state.uploadSection.uploadValidationMessages.length > 0 ?
                                                <div>
                                                    <UserMessage text={this.getValidationMessageList()} variant={MessageType.Error} />
                                                </div> :
                                                ""}
                                            <div>
                                                <Dropzone
                                                    accept={{
                                                        'text/csv': ['.csv'],
                                                        'application/xml': ['.xml'],
                                                        'text/plain': ['.txt']
                                                    }}
                                                    onDrop={this.onDrop.bind(this)}
                                                    onDropAccepted={this.onDropAccepted}
                                                    onDropRejected={this.onDropRejected}
                                                >
                                                    {({ getRootProps, getInputProps }) => (
                                                        <div
                                                            {...getRootProps()}
                                                            className={classes.DropzoneContainer + " " + classNames(classes.dropZone, this.state.uploadSection.dropzoneStatusStyle)}
                                                        >
                                                            <input {...getInputProps()} />
                                                            <Grid container={true} justifyContent="center" alignItems="center" direction="column">
                                                                <Grid size={12}>
                                                                    <Typography className={classes.dropzoneText} variant="h6" color="textPrimary">
                                                                        Drag and drop file here
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid size={12}>
                                                                    <Typography className={classes.dropzoneText} variant="h6" color="textPrimary">
                                                                        or
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid size={12} display="flex" justifyContent="center">
                                                                    <Fab className={classes.squareFab + " " + classes.dropzoneBtn} variant="extended" color="primary">
                                                                        Select File
                                                                    </Fab>
                                                                </Grid>
                                                                <Grid size={12}>
                                                                    <Typography className={classes.dropzoneText} variant="subtitle1" color="textPrimary">
                                                                        Allowable format : {this.state.submissionData.requiredFileName} <br />
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </div>
                                                    )}
                                                </Dropzone>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                {this.state.uploadSection.uploadCompletionPercent > 0 ? <Typography>Status:  </Typography> : null}
                                                            </td>
                                                            <td>
                                                                {this.state.uploadSection.uploadCompletionPercent > 0 && this.state.uploadSection.uploadCompletionPercent !== 100 ? <CircularProgress variant="determinate" value={this.state.uploadSection.uploadCompletionPercent} /> : ""}
                                                                <Typography className={classes.darkOrangeColor}>{this.state.uploadSection.uploadCompletionPercent === 100 && !this.state.uploadSection.fileProcessingComplete ? "Processing" : null}</Typography>
                                                                <Typography className={classes.greenColor}>{this.state.uploadSection.uploadCompletionPercent === 100 && this.state.uploadSection.fileProcessingComplete ? "Complete" : null}</Typography>
                                                            </td>
                                                            <td>
                                                                {this.state.uploadSection.uploadCompletionPercent === 100 ? <ProcessingDisplay completed={this.state.uploadSection.fileProcessingComplete} /> : null}
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        : <Typography color={"secondary"}>{this.state.submissionData.fileUploadNotAllowedReason}</Typography>}
                                </CardContent>
                            </Card>
                        </Grid>
                    </> : null
                    }

                    {this.state.submissionData.isFileProcessed && (!this.state.submissionData.didValidationError || this.state.isSysAdmin) ?
                        <Grid key={3} size={6} className={classes.gridDisplay}>
                            {this.state.uploadSection.uploadCompletionPercent === 100 && !this.state.uploadSection.fileProcessingComplete ?
                                <Card className={classes.card}>
                                    <CardContent>
                                        <Typography className={classes.primaryBlue + " " + classes.marginBottom}>
                                            {lockTitle}
                                        </Typography>
                                        <LoadingDataTable />
                                    </CardContent>
                                    <CardActions>
                                        <Fab disabled variant="extended">Apply Plan Lock</Fab>
                                    </CardActions>
                                </Card> :
                                <Fade in={!(this.state.uploadSection.uploadCompletionPercent === 100 && !this.state.uploadSection.fileProcessingComplete)}>
                                    <Card className={classes.card}>
                                        <CardContent>
                                            <Typography className={classes.primaryBlue + " " + classes.marginBottom}>
                                                {lockTitle}
                                            </Typography>
                                            <Typography variant='body1' color='secondary' className={classes.marginTop} >
                                                {
                                                    (this.state.submissionData.didValidationError ?
                                                        (this.state.isSysAdmin && !isHOS ? "This submission has Validation Error(s).  You may only lock it because you are a NCQA Admin." :
                                                            isCahps || isHOS ? "Your submission has Validation Error(s).  You may not proceed to the next stage." : "Your submission has Validation Error(s).  You may not Plan Lock.") : null)
                                                }
                                            </Typography>
                                            <Typography variant='body1' color='secondary'>
                                                {
                                                    !this.state.submissionData.didValidationError && this.state.submissionData.didValidationWarning ?
                                                        <>Your submission has encountered Validation warnings. Please review all warnings and verify the data are correct before proceeding.</> : null
                                                }
                                                <Typography variant='body1' color='primary' className={classes.mt1}>
                                                    {isHedis && !this.state.submissionData.didValidationError && this.state.userAction.canPlanLock ?
                                                        <>Your data has been validated and ready for plan lock!

                                                            Apply the plan lock after you have reviewed your data through the Auditor Review Table or Submissions Downloads.
                                                            Your auditor will review once the lock is applied.
                                                        </>
                                                        : null
                                                    }
                                                    {isCahps && !this.state.userAction.canMarkFinalCahps ?
                                                        <>Waiting for Vendor Admin or Vendor User to apply Mark Final.</> : null
                                                    }
                                                    {isHOS && !this.state.submissionData.didValidationError ? <>
                                                        {this.state.userAction.canSignAttestationHos ?
                                                            <>Please perform attestation and mark final processes using the bulk operation.</>
                                                            :
                                                            <>Only your organization's Designated Signer may sign the attestation and mark files final.
                                                                Please have the Designated Signer log into IDSS, sign the attestation, and mark submissions final.</>
                                                        }
                                                    </> : null
                                                    }
                                                </Typography>
                                            </Typography>
                                        </CardContent>
                                        <CardActions>
                                            {isCahps && this.state.userAction.canMarkFinalCahps ? this.renderCahpsCanMarkFinal() : null}
                                            {isHedis && this.state.userAction.canPlanLock ?
                                                <div>
                                                    <Fab disabled={this.state.submissionData.didValidationError && !this.state.isSysAdmin} variant="extended" color="primary" onClick={() => { this.setState({ dialogStatus: { ...this.state.dialogStatus, planLockOpen: true } }) }}>
                                                        Apply Plan Lock
                                                    </Fab>
                                                    <Dialog
                                                        open={this.state.dialogStatus.planLockOpen}
                                                        aria-labelledby="alert-dialog-title"
                                                        aria-describedby="alert-dialog-description"
                                                        TransitionComponent={Transition}
                                                    >
                                                        <DialogTitle id="alert-dialog-title"><Typography className={classes.primaryBlueSmall}>{this.state.dialogStatus.planLockTitle}</Typography></DialogTitle>
                                                        <DialogContent>
                                                            <DialogContentText id="alert-dialog-description">
                                                                <Typography className={classes.secondaryText}>{this.state.dialogStatus.planLockText}</Typography>
                                                            </DialogContentText>
                                                        </DialogContent>
                                                        <DialogActions>
                                                            <Button onClick={() => { this.setState({ dialogStatus: { ...this.state.dialogStatus, planLockOpen: false } }) }} className={classes.disabledButton} disabled={this.state.isGenericActionHappening}>
                                                                Cancel
                                                            </Button>
                                                            <Button onClick={() => this.executePlanAction(SubmissionActionTypes.PlanLock)} autoFocus disabled={this.state.isGenericActionHappening}>
                                                                Continue
                                                            </Button>
                                                        </DialogActions>
                                                    </Dialog>
                                                </div>
                                                : null
                                            }
                                        </CardActions>
                                    </Card></Fade>}
                        </Grid> : null}

                    {this.state.submissionData.isFileProcessed && ((isHedis && this.state.userAction.canViewDownloadErrorsHedis) || (!isHedis && this.state.userAction.canViewDownloadErrorsNonHedis)) &&
                        <Grid key={2} size={6} className={classes.gridDisplay}>
                            <Card className={classes.card}>
                                {(this.state.uploadSection.uploadCompletionPercent === 100 
                                                && !this.state.uploadSection.fileProcessingComplete) || this.state.isValidationTableLoading !== true ?
                                    <CardContent>
                                        <LoadingDataTable titleText="Validations" />
                                    </CardContent>
                                    : this.state.validation.validationErrors.length > 0 ?
                                        <ValidationTable
                                            validation={this.state.validation}
                                            submissionData={this.state.submissionData}
                                            component={this.state.submissionData.component}
                                            submissionDownloads={this.state.submissionData.submissionDownloads}
                                            classes={classes}
                                        />
                                        :
                                        <CardContent>
                                            <Typography className={classes.primaryBlue + " " + classes.marginBottom}>
                                                Validations
                                            </Typography>
                                            <Typography variant='body1' color='primary' className={classes.marginTop}>
                                                This submission has no validation errors.
                                            </Typography>
                                        </CardContent>
                                }
                            </Card>
                        </Grid>
                    }

                    {(adjustedStepNumber !== IMPORT_SUBMISSION_STEP) && (!isCahps || !this.state.submissionData.didValidationError) ?
                        <Grid key={4} size={6} className={classes.gridDisplay}>
                            {this.renderSubmissionDownloads(isHedis)}
                        </Grid> : null}
                    <Grid key={5} size={4} className={classes.gridDisplay}>
                        {this.renderSubmissionDetails()}
                    </Grid>
                    {isCahps ?
                        <Grid key={6} size={2}>
                        </Grid> : null}
                </>
            case AUDIT_LOCK_STEP:
                return <>
                    {this.state.userAction.canAuditLock && this.state.submissionData.isAuditRequired ? <>
                        <Grid key={1} size={4} className={classes.gridDisplay}>
                            {this.state.submissionData.isFileProcessed ?
                                <Card className={classes.card}>
                                    <CardContent>
                                        <Typography className={classes.primaryBlue}>
                                            Audit Lock
                                        </Typography>
                                        <br />
                                        {this.state.userAction.canAuditLock ?
                                            <Typography variant='body1' color='primary'>
                                                Submission data are ready to be reviewed.

                                                Use the Submission Downloads or Bulk downloads section (on the left panel) to review reports.
                                                The Auditor Review Table should be used to make any audit designation changes.
                                            </Typography> : null
                                        }
                                        {!(this.state.userAction.canPlanUnlock || this.state.userAction.canAuditLock) ?
                                            <Typography variant='body1' color='primary'>
                                                {this.state.dialogStatus.auditLockNoActionText}
                                            </Typography> : null
                                        }
                                    </CardContent>
                                    <CardActions>
                                        {this.state.userAction.canAuditLock ?
                                            <>
                                                <Fab variant="extended" color="primary" onClick={() => { this.setState({ dialogStatus: { ...this.state.dialogStatus, auditLockOpen: true } }) }}>
                                                    Apply Audit Lock
                                                </Fab>
                                                <Dialog
                                                    open={this.state.dialogStatus.auditLockOpen}
                                                    aria-labelledby="alert-dialog-title"
                                                    aria-describedby="alert-dialog-description"
                                                    TransitionComponent={Transition}
                                                >
                                                    <DialogTitle id="alert-dialog-title"><Typography className={classes.primaryBlueSmall}>{this.state.dialogStatus.auditLockTitle}</Typography></DialogTitle>
                                                    <DialogContent>
                                                        <DialogContentText id="alert-dialog-description">
                                                            <Typography className={classes.secondaryText}>{this.state.dialogStatus.auditLockText}</Typography>
                                                        </DialogContentText>
                                                    </DialogContent>
                                                    <DialogActions>
                                                        <Button onClick={() => { this.setState({ dialogStatus: { ...this.state.dialogStatus, auditLockOpen: false } }) }} className={classes.disabledButton} disabled={this.state.isGenericActionHappening}>
                                                            Cancel
                                                        </Button>
                                                        <Button onClick={() => this.executePlanAction(SubmissionActionTypes.AuditLock)} autoFocus disabled={this.state.isGenericActionHappening}>
                                                            Continue
                                                        </Button>
                                                    </DialogActions>
                                                </Dialog>
                                            </> : null
                                        }
                                        {this.state.userAction.canPlanUnlock ?
                                            this.renderUndoPlanLock() : null
                                        }
                                    </CardActions>
                                </Card> :
                                null}
                        </Grid>
                    </> : null}
                    <Grid key={2} size={4} className={classes.gridDisplay}>
                        {this.renderSubmissionDownloads(isHedis)}
                    </Grid>

                    <Grid key={3} size={4} className={classes.gridDisplay}>
                        {this.renderSubmissionDetails()}
                    </Grid>
                </>
                break;
            case MARK_FINAL_HEDIS_HOS_STEP:
                return <>
                    {(isHedis && (this.state.userAction.canMarkFinalHedis || this.state.userAction.canAuditUnlock)) || (isHOS) ?
                        <Grid key={6} size={(this.state.submissionData.isFileProcessed && this.state.attestation.attestationStarted) ? 8 : 4 } className={classes.gridDisplay}>
                            {this.state.submissionData.isFileProcessed ?
                                this.state.attestation.attestationStarted && (!isCahps || isCahpsOnly) && (canReportOrSignHedis) ?
                                    <Card className={classes.card}>
                                        <CardContent>
                                            <AttestationSteps
                                                submissionId={this.state.submissionData.subId}
                                                component={this.state.submissionData.component}
                                                title={this.state.attestation.attestationTitle}
                                                description={this.state.attestation.attestationText}
                                                isPublicReporting={this.state.submissionData.isPublicReported}
                                                canManagePublicReporting={this.state.userAction.canManagePublicReporting}
                                                canEsignAttestation={this.state.userAction.canSignAttestationHedis}
                                                onComplete={this.handleAttestationStepsComplete}
                                                onCancel={this.handleAttestationStepsCancel}
                                                isLtss={this.state.submissionData.specialProject === "LTSS"}
                                                isYesAllowed={this.state.submissionData.productLine !== "Exchange"}
                                            />
                                        </CardContent>
                                    </Card>
                                    :
                                    <Card className={classes.card}>
                                        <CardContent>
                                            <Typography className={classes.primaryBlue}>
                                                Finalization
                                            </Typography>
                                            <Typography variant='body1' color='secondary' className={classes.marginTop} >
                                                {
                                                    (this.state.submissionData.didValidationError ?
                                                        (this.state.isSysAdmin && !isHOS ? "This submission has Validation Error(s).  You may only lock it because you are a NCQA Admin." :
                                                            isCahps || isHOS ? "Your submission has Validation Error(s).  You may not proceed to the next stage." : "Your submission has Validation Error(s).  You may not Plan Lock.") : null)
                                                }
                                            </Typography>
                                        </CardContent>
                                        {isHedis ?
                                            <CardActions>
                                                <div>
                                                    {this.state.userAction.canMarkFinalHedis ?
                                                        <Fab variant="extended" color="primary" onClick={() => { this.setState({ dialogStatus: { ...this.state.dialogStatus, markFinalOpen: true } }) }}>
                                                            Apply Mark Final
                                                        </Fab> : null
                                                    }
                                                    <Dialog
                                                        open={this.state.dialogStatus.markFinalOpen}
                                                        aria-labelledby="alert-dialog-title"
                                                        aria-describedby="alert-dialog-description"
                                                        TransitionComponent={Transition}
                                                    >
                                                        <DialogTitle id="alert-dialog-title"><Typography className={classes.primaryBlueSmall}>{this.state.dialogStatus.markFinalTitle}</Typography></DialogTitle>
                                                        <DialogContent>
                                                            <DialogContentText id="alert-dialog-description">
                                                                <Typography className={classes.secondaryText}>{this.state.dialogStatus.markFinalText}</Typography>
                                                            </DialogContentText>
                                                        </DialogContent>
                                                        <DialogActions>
                                                            <Button onClick={() => { this.setState({ dialogStatus: { ...this.state.dialogStatus, markFinalOpen: false } }) }} className={this.props.classes.disabledButton} disabled={this.state.isGenericActionHappening}>
                                                                Cancel
                                                            </Button>
                                                            <Button onClick={() => this.executePlanAction(SubmissionActionTypes.MarkFinal)} autoFocus disabled={this.state.isGenericActionHappening}>
                                                                Continue
                                                            </Button>
                                                        </DialogActions>
                                                    </Dialog>
                                                </div>
                                                {this.state.userAction.canAuditUnlock && this.state.submissionData.isAuditRequired ?
                                                    <div>
                                                        <Fab variant="extended" color="secondary" onClick={() => { this.setState({ dialogStatus: { ...this.state.dialogStatus, auditLockUndoOpen: true } }) }}>
                                                            Undo Audit Lock
                                                        </Fab>
                                                        <Dialog
                                                            open={this.state.dialogStatus.auditLockUndoOpen}
                                                            aria-labelledby="alert-dialog-title"
                                                            aria-describedby="alert-dialog-description"
                                                            TransitionComponent={Transition}
                                                        >
                                                            <DialogTitle id="alert-dialog-title"><Typography className={classes.primaryBlueSmall}>{this.state.dialogStatus.auditLockUndoTitle}</Typography></DialogTitle>
                                                            <DialogContent>
                                                                <DialogContentText id="alert-dialog-description">
                                                                    <Typography className={classes.secondaryText}>{this.state.dialogStatus.auditLockUndoText}</Typography>
                                                                </DialogContentText>
                                                            </DialogContent>
                                                            <DialogActions>
                                                                <Button onClick={() => { this.setState({ dialogStatus: { ...this.state.dialogStatus, auditLockUndoOpen: false } }) }} className={this.props.classes.disabledButton} disabled={this.state.isGenericActionHappening}>
                                                                    Cancel
                                                                </Button>
                                                                <Button onClick={() => this.executePlanAction(SubmissionActionTypes.AuditUnlock)} autoFocus disabled={this.state.isGenericActionHappening}>
                                                                    Continue
                                                                </Button>
                                                            </DialogActions>
                                                        </Dialog>
                                                    </div> : null
                                                }
                                                {this.state.userAction.canPlanUnlock && !this.state.submissionData.isAuditRequired ?
                                                    this.renderUndoPlanLock() : null
                                                }

                                            </CardActions> : null
                                        }
                                    </Card>
                                : null}
                        </Grid>
                        : null}
                    <Grid key={2} size={4} className={classes.gridDisplay}>
                        {this.renderSubmissionDownloads(isHedis)}
                    </Grid>
                    <Grid key={3} size={4} className={classes.gridDisplay}>
                        {this.renderSubmissionDetails()}
                    </Grid>


                </>
                break;
            case ATTESTATION_CAHPS_STEP:
            case ATTESTATION_HEDIS_STEP:
                const attestationCondition1 = isHedis && canReportOrSignHedis;
                const attestationCondition2 = isCahps;
                const attestationCondition3 = isHOS && (canPublicReport || this.state.userAction.canSignAttestationHos);
                const overallAttestationAccess = attestationCondition1 || attestationCondition2 || attestationCondition3;

                const attestationStepsCondition = this.state.attestation.attestationStarted && (!isCahps || isCahpsOnly) && canReportOrSignHedis;
                return <>
                    {overallAttestationAccess ? <>
                        <Grid key={6} size={(this.state.submissionData.isFileProcessed && this.state.attestation.attestationStarted) ? 8 : 4 } className={classes.gridDisplay}>
                            {this.state.submissionData.isFileProcessed ?
                                attestationStepsCondition ?
                                    <Card className={classes.card}>
                                        <CardContent>
                                            <AttestationSteps
                                                submissionId={this.state.submissionData.subId}
                                                component={this.state.submissionData.component}
                                                title={this.state.attestation.attestationTitle}
                                                description={this.state.attestation.attestationText}
                                                isPublicReporting={this.state.submissionData.isPublicReported}
                                                canManagePublicReporting={this.state.userAction.canManagePublicReporting}
                                                canEsignAttestation={this.state.userAction.canSignAttestationHedis}
                                                onComplete={this.handleAttestationStepsComplete}
                                                onCancel={this.handleAttestationStepsCancel}
                                                isLtss={this.state.submissionData.specialProject === "LTSS"}
                                                isYesAllowed={this.state.submissionData.productLine !== "Exchange"}
                                            />
                                        </CardContent>
                                    </Card>
                                    :
                                    <Card className={classes.card}>
                                        <CardContent>
                                            <Typography className={classes.primaryBlue}>
                                                Attestation
                                            </Typography>
                                            {!SharedUtility.IsNullOrUndefined$(this.state.submissionData.isPublicReported) && !SharedUtility.IsNullOrUndefined$(this.state.submissionData.reportableEvents) ?
                                                <React.Fragment>
                                                    <Typography variant='body1' color='primary' className={classes.mt2}>
                                                        Public Reporting: <strong>{this.state.submissionData.isPublicReported ? 'Yes' : 'No'}</strong>
                                                    </Typography>
                                                </React.Fragment> : null}
                                            {/* isHedis - This is true when a submission contains HEDIS/DST component */}
                                            {/* isCahps - This is true when a submission contains HEDIS & CAHPS components */}
                                            {/* isCahpsOnly - This is true when a submission contains only CAHPS component */}
                                            {/* isVendor - This is true when a user has vendoruser access or a NCQA ADMIN */}
                                            {/* canPublicReport - This is true when a user has Public Reporting access or a NCQA ADMIN */}
                                            <Typography variant='body1' color='primary' className={classes.mt2}>
                                                All the system generated files are available for download from "All Downloads" tab.
                                            </Typography>
                                            {
                                                ((isHedis || (isCahps && isCahpsOnly)) && !canPublicReport) ?
                                                    <Typography variant='body1' color='primary' className={classes.mt2}>
                                                        {this.state.dialogStatus.attestationNoActionText}
                                                    </Typography> : null
                                            }
                                        </CardContent>
                                        <CardActions>
                                            {
                                                (isCahps && isCahpsOnly && canPublicReport)
                                                    ? <div>
                                                        <Fab variant="extended" color="primary" onClick={() => { this.setState({ attestation: { ...this.state.attestation, attestationStarted: true } }) }}>
                                                            {SharedUtility.IsNullOrUndefined$(this.state.submissionData.reportableEvents) ? "Start Attestation" : "Change Attestation"}
                                                        </Fab>
                                                    </div> : null
                                            }
                                            {
                                                (isHedis && (canPublicReport || canSignHedis)) ||
                                                    (isHOS && (canPublicReport || this.state.userAction.canSignAttestationHos))
                                                    ?
                                                    <div>
                                                        <Fab variant="extended" color="primary" onClick={() => { this.setState({ attestation: { ...this.state.attestation, attestationStarted: true } }) }}>
                                                            {SharedUtility.IsNullOrUndefined$(this.state.submissionData.reportableEvents) ? "Start Attestation" : "Change Attestation"}
                                                        </Fab>
                                                    </div>
                                                    : null
                                            }
                                            {this.state.userAction.canSubmissionGenericAdmin ?
                                                <div>
                                                    <Fab variant="extended" color="secondary" onClick={() => { this.setState({ dialogStatus: { ...this.state.dialogStatus, markFinalUndoOpen: true } }) }}>
                                                        UnMark Final
                                                    </Fab>
                                                    <Dialog
                                                        open={this.state.dialogStatus.markFinalUndoOpen}
                                                        aria-labelledby="alert-dialog-title"
                                                        aria-describedby="alert-dialog-description"
                                                        TransitionComponent={Transition}
                                                    >
                                                        <DialogTitle id="alert-dialog-title"><Typography sx={{ color: '#4F758B', fontSize: '0.9em', fontWeight: 'bold' }}>{this.state.dialogStatus.markFinalUndoTitle}</Typography></DialogTitle>
                                                        <DialogContent>
                                                            <DialogContentText id="alert-dialog-description">
                                                                <Typography sx={{ color: '#666', fontSize: '0.875em' }}>{this.state.dialogStatus.markFinalUndoText}</Typography>
                                                            </DialogContentText>
                                                        </DialogContent>
                                                        <DialogActions>
                                                            <Button onClick={() => { this.setState({ dialogStatus: { ...this.state.dialogStatus, markFinalUndoOpen: false } }) }} sx={{ backgroundColor: '#f5f5f5', color: '#999' }} disabled={this.state.isGenericActionHappening}>
                                                                Cancel
                                                            </Button>
                                                            <Button onClick={() => this.executePlanAction(SubmissionActionTypes.MarkFinalUnlock)} autoFocus disabled={this.state.isGenericActionHappening}>
                                                                Continue
                                                            </Button>
                                                        </DialogActions>
                                                    </Dialog>
                                                </div> : null
                                            }
                                        </CardActions>
                                    </Card>
                                : null}
                        </Grid >
                    </> :
                        <Grid key={6} size={4} className={classes.gridDisplay}>
                            <Card className={classes.card}>
                                <CardContent>
                                    <Typography className={classes.primaryBlue}>
                                        Attestation
                                    </Typography>
                                    <Typography variant='body1' color='primary'>
                                        No further actions are needed on your part. Designated organization users should proceed to complete the submission.
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    }
                    {isCahps ?
                        <Grid key={2} size={6} className={classes.gridDisplay}>
                            {this.renderSubmissionDownloads(isHedis)}
                        </Grid> : null
                    }
                    <Grid key={3} size={4} className={classes.gridDisplay}>
                        {this.renderSubmissionDetails()}
                    </Grid>


                </>
                break;
            case COMPLETE_STEP:
                return <>
                    <Grid key={6} size={6} className={classes.gridDisplay}>
                        <Card className={classes.card}>
                            <CardContent>
                                <div>
                                    {
                                        isHedis ?
                                            <Typography variant='body1' color='primary'>
                                                Congratulations! Submission process complete. <br /> <br />
                                                Download final files from the "All downloads" tab or "Bulk Downloads" on the left panel.
                                            </Typography> :
                                            <Typography variant='body1' color='primary'>
                                                Submission process complete.
                                            </Typography>
                                    }
                                </div>
                            </CardContent>
                            <CardActions>
                                {this.state.userAction.canSubmissionGenericAdmin ?
                                    <div>
                                        <Fab variant="extended" color="secondary" onClick={() => { this.setState({ dialogStatus: { ...this.state.dialogStatus, attestationUndoOpen: true } }) }}>
                                            Rollback
                                        </Fab>
                                        <Dialog
                                            open={this.state.dialogStatus.attestationUndoOpen}
                                            aria-labelledby="alert-dialog-title"
                                            aria-describedby="alert-dialog-description"
                                            TransitionComponent={Transition}
                                        >
                                            <DialogTitle id="alert-dialog-title"><Typography sx={{ color: '#4F758B', fontSize: '0.9em', fontWeight: 'bold' }}>{this.state.dialogStatus.attestationUndoTitle}</Typography></DialogTitle>
                                            <DialogContent>
                                                <DialogContentText id="alert-dialog-description">
                                                    <Typography sx={{ color: '#666', fontSize: '0.875em' }}>{this.state.dialogStatus.attestationUndoText}</Typography>
                                                </DialogContentText>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={() => { this.setState({ dialogStatus: { ...this.state.dialogStatus, attestationUndoOpen: false } }) }} sx={{ backgroundColor: '#f5f5f5', color: '#999' }} disabled={this.state.isGenericActionHappening}>
                                                    Cancel
                                                </Button>
                                                {isCahps || isHOS ?
                                                    <Button onClick={() => this.executePlanAction(SubmissionActionTypes.MarkFinalUnlock)} autoFocus disabled={this.state.isGenericActionHappening}>
                                                        Continue
                                                    </Button> :
                                                    <Button onClick={() => this.handleAttestationUndo()} autoFocus disabled={this.state.isGenericActionHappening}>
                                                        Continue
                                                    </Button>}
                                            </DialogActions>
                                        </Dialog>
                                    </div> : null
                                }
                            </CardActions>
                        </Card>
                    </Grid>
                    {isCahps ?
                        <Grid key={2} size={6} className={classes.gridDisplay}>
                            {this.renderSubmissionDownloads(isHedis)}
                        </Grid> : null
                    }

                    <Grid key={3} size={3} className={classes.gridDisplay}>
                        {this.renderSubmissionDetails()}
                    </Grid>
                </>
            default:
                return <div>This is not a valid stage</div>;
        }
    }

    private onDropRejected = (fileRejections) => {
        const { classes } = this.props;
        this.setState({
            uploadSection: {
                ...this.state.uploadSection,
                uploadValidationMessages: [this.CreateValidationMessage('Please select a valid file')],
                dropzoneStatusStyle: classes.rejectStripes
            }
        });
    }

    private onDropAccepted = (fileAcception) => {
        const { classes } = this.props;
        this.setState({
            uploadSection: {
                ...this.state.uploadSection,
                uploadCompletionPercent: 0,
                fileProcessingComplete: false,
                uploadValidationMessages: [],
                dropzoneStatusStyle: classes.stripes
            }
        });
    }

    public onDrop(files) {
        var validForUpload = true;
        this.setState({ uploadSection: { ...this.state.uploadSection, uploadCompletionPercent: 0 } });
        this.setState({ uploadSection: { ...this.state.uploadSection, fileProcessingComplete: false } });
        const data = new FormData();
        this.setState({ uploadSection: { ...this.state.uploadSection, uploadValidationMessages: [] } });
        if (files.length === 0) {
            this.setState({ uploadSection: { ...this.state.uploadSection, uploadValidationMessages: [this.CreateValidationMessage('Please select a valid file')] } });
            validForUpload = false;
        }

        let submissionType = this.state.component;
        files.forEach(file => {
            if (submissionType === "DST") {
                if (file.name === null || !file.name.toLocaleLowerCase().includes(this.state.submissionData.productLine.toLocaleLowerCase())
                    || !file.name.toLocaleLowerCase().includes(this.state.submissionData.subId.toString().toLocaleLowerCase())) {
                    this.setState({ uploadSection: { ...this.state.uploadSection, uploadValidationMessages: [this.CreateValidationMessage('Invalid file name (need to include product line and submission ID for the current submission).')] } });
                    validForUpload = false;
                    return;
                }
            }
            else {
                if (file.name === null || !file.name.toLocaleLowerCase().includes(this.state.submissionData.subId.toString().toLocaleLowerCase())) {
                    this.setState({ uploadSection: { ...this.state.uploadSection, uploadValidationMessages: [this.CreateValidationMessage('Invalid file name.  Submission ID must match the current submission.')] } });
                    validForUpload = false;
                    return;
                }
            }
            data.append("files", file, file.name);
        });


        if (submissionType === "DST") {
            submissionType = "HEDIS";
        }

        if (validForUpload) {
            const req = request.post(process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + "/api/bulkupload/uploadfiles");
            req.query({ submissionType: submissionType });
            req.query({ submissionId: this.state.submissionData.subId });
            req.set({ 'Authorization': 'Bearer ' + this.props.user.access_token });

            // show upload progress 
            req.on('progress', event => {
                const percent = Math.floor(event.percent);
                if (!isNaN(percent)) {
                    if (percent >= 100) {
                        this.setState({ uploadSection: { ...this.state.uploadSection, uploadCompletionPercent: 100 } });
                    } else {
                        this.setState({ uploadSection: { ...this.state.uploadSection, uploadCompletionPercent: percent } });
                    }
                }
            });
            this.setState({ uploadSection: { ...this.state.uploadSection, uploadFiles: files } });
            // send file(s) to server
            req.send(data)
                .end((err, res) => this.postUploadFiles(err, res));
        }
    }

    private handleAttestationFlagChange(attestationFlag, checked) {
        switch (attestationFlag) {
            case "PublicReporting":
                this.setState({ submissionData: { ...this.state.submissionData, isPublicReported: checked } });
                break;
            case "Somc":
                this.setState({ submissionData: { ...this.state.submissionData, somc: checked } });
                break;
            default:
                break;
        }
    }

    private async postUploadFiles(err, res) {
        if (err) {
            this.setState({ uploadSection: { ...this.state.uploadSection, uploadValidationMessages: [this.CreateValidationMessage("Upload not Successful")] } });
        }
        else {
            this.setState({ validationResult: res.body.uploadDetail.validationResult });
            if (res.body.success) {
                this.setState({
                    uploadSection: {
                        ...this.state.uploadSection,
                        fileProcessingComplete: true,
                        uploadSuccessful: true
                    }
                });
            }
            else {
                this.setState({
                    uploadSection: {
                        ...this.state.uploadSection,
                        fileProcessingComplete: true,
                        uploadSuccessful: false,
                        uploadValidationMessages: res.body.uploadDetail.validationResult.messages
                    }
                });
            }


            await this.getSubmissionSummary(true);
        }
    }


    private executePlanAction = async (action: SubmissionActionTypes): Promise<void> => {
        this.setState({ isGenericActionHappening: true });

        try {
            const apiCall$ = SubmissionsService.ExecutePlanAction$(
                    this.props.user,
                    this.state.currentSubId,
                    this.state.submissionData.component,
                    action
                );

            const userResponse = await firstValueFrom(apiCall$);

            if (!userResponse) {
                throw new Error('Empty response from ExecutePlanAction');
            }

            this.setState(prev => ({
            dialogStatus: {
                ...prev.dialogStatus,
                markFinalUndoOpen: false,
                markFinalOpen: false,
                planLockOpen: false,
                auditLockUndoOpen: false,
                auditLockOpen: false,
                planLockUndoOpen: false,
                attestationUndoOpen: false
            },
            attestation: {
                ...prev.attestation,
                attestationStarted: false
            }
            }));

            await this.getSubmissionSummary(true);
        } catch (error) {
            setRedirectState(this);
        } finally {
            this.setState({ isGenericActionHappening: false });
        }
    };

    private handleAttestationUndo = async () => {
        this.setState({ isGenericActionHappening: true });
        const apiCall = SubmissionsService.UndoSubmissionAttestation$(this.props.user, this.state.currentSubId, this.state.component);
        const undoResponse = await firstValueFrom(apiCall);
        if (undoResponse instanceof AjaxError || !undoResponse) {
            setRedirectState(this);
        } else {
            await this.executePlanAction(SubmissionActionTypes.AttestationUndo);
        }
        this.setState({ isGenericActionHappening: false });
    }

    private async unSubmitFile() {
        this.setState({ isGenericActionHappening: true });
        const retval = await firstValueFrom(
            SubmissionsService.UnSubmitFile$(this.props.user, this.state.submissionData.subId, this.state.submissionData.component)
        );
        this.setState({ uploadSection: { ...this.state.uploadSection, uploadCompletionPercent: 0 } });
        this.setState({ uploadSection: { ...this.state.uploadSection, fileProcessingComplete: false } });
        this.setState({ uploadSection: { ...this.state.uploadSection, uploadValidationMessages: [] } });
        if (retval instanceof AjaxError || !retval) {
            setRedirectState(this);
        }
        else {
            this.setState({ dialogStatus: { ...this.state.dialogStatus, clearMeasuresOpen: false } });
            this.setState({ currentTabVal: 0 });
            await this.getSubmissionSummary(true);
            this.setState({ isGenericActionHappening: false });
            alert("All measures data from this submission has been cleared.")
        }
    }

    private async reprocessSubmission() {
        const groupId = uuidv4();
        const retval = await firstValueFrom(
            SubmissionsService.ReprocessSubmission$(this.props.user, this.state.submissionData.subId, this.state.submissionData.component, groupId)
        );
        if (retval instanceof AjaxError || !retval) {
            setRedirectState(this);
        }
    }

    private async updateSubmissionAttestationFlags() {
        this.setState({ isAdminUpdatingAttestFlags: true });
        const attestationFlags: ISubmissionAttestationFlags = {
            submissionId: this.state.submissionData.subId,
            component: this.state.submissionData.component,
            isPublicReported: this.state.submissionData.isPublicReported || false,
            somc: this.state.submissionData.somc || false,
            sourceLastModified: this.state.submissionData.attestationModifiedDate
        };
        const retval = await firstValueFrom(
            SubmissionsService.UpdateSubmissionAttestationFlags$(this.props.user, attestationFlags)
        );
        if (retval instanceof AjaxError || !retval) {
            setRedirectState(this);
        } else {
            this.setState({ isFlagUpdateSuccessful: true },
                () => setTimeout(() => {
                    this.setState({ isFlagUpdateSuccessful: false });
                }, 3000));
            await this.getSubmissionSummary(true);
        }

        this.setState({ isAdminUpdatingAttestFlags: false });
    }

    private CreateValidationMessage = (message: string): ValidationMessage => {
        return { message: message, severity: 4 };
    }

    private getValidationMessageList = () => {
        const isCahps = this.state.component.includes("CAHPS");
        var message = 'Validation issues found';
        if (isCahps) {
            message = 'Validation errors found';
        }
        if (this.state.uploadSection.uploadValidationMessages.length > 1
            || this.state.uploadSection.uploadValidationMessages.filter(m => m.message === "Revise" || m.message === "Review").length >= 1) {
            return (<div>{message}</div>);
        }
        else {
            return (
                <ul style={{ margin: "0", listStyle: "none" }}>
                    {this.state.uploadSection.uploadValidationMessages.map(function (valMessage, i) {
                        return (<li key={"message" + i} dangerouslySetInnerHTML={{ __html: SharedUtility.NewLinesToBreaks$(valMessage.message) }}></li>)
                    })}
                </ul>
            );
        }

    }

    private renderSubmissionDetails = () => {
        const { classes } = this.props;
        return (Renderings.renderSubmissionSummary(this.state.auths, this.state.submissionData, classes))
    }

    private renderSubmissionDownloads = (isHedis: boolean) => {
        const { classes } = this.props;
        const showValidation = (isHedis && this.state.userAction.canViewDownloadErrorsHedis) || (!isHedis && this.state.userAction.canViewDownloadErrorsNonHedis);
        return (isHedis && this.state.userAction.canDownloadResultHedis) || (!isHedis && (this.state.userAction.canDownloadResultCahps || this.state.userAction.canDownloadResultHos)) ? <>
            <Card className={classes.card}>
                {this.state.uploadSection.uploadCompletionPercent === 100 && !this.state.uploadSection.fileProcessingComplete ?
                    <CardContent>
                        <Typography className={classes.primaryBlue + " " + classes.marginBottom}>
                            Submission Downloads
                        </Typography>
                        <LoadingDataTable  />
                    </CardContent>
                    :
                    <CardContent>
                        <Typography className={classes.primaryBlue}>
                            Submission Downloads
                        </Typography>
                        <Typography variant='body2' color='inherit'>
                            Contains available downloads
                        </Typography>
                        <div>
                            {this.state.submissionData.submissionDownloads.filter(x => !x.isArchived && !x.isAllDownloadsOnly && !x.isLicense && (showValidation || !x.displayName.toLocaleLowerCase().includes("validation"))).map((tile, i) => (
                                <div key={"Download" + i} >
                                    <Grid container={true} spacing={1}>
                                        <Grid size={9}>
                                            <Typography variant='body2' color="inherit"  >
                                                <Button
                                                    color='primary'
                                                    style={{ fontWeight: 'bold', backgroundColor: 'transparent', color: 'DimGray' }}
                                                    className={classes.button}
                                                    onClick={() => this.downloadFile(tile.key)}
                                                    startIcon={<InsertDriveFile />}
                                                >
                                                    {tile.displayName}
                                                </Button>
                                            </Typography>
                                            <Typography variant='body2' color="textSecondary" style={{ paddingLeft: '10px' }}>
                                                {tile.explanation}
                                            </Typography>
                                        </Grid>
                                        <Grid size={3}>
                                            <Typography variant='subtitle2' color="inherit" style={{ fontWeight: 'bold', paddingTop: '7px' }}>{tile.uploadDay}</Typography>
                                            <Typography variant='body2' color="inherit">{tile.uploadTime}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Divider></Divider>
                                </div>
                            ))}
                        </div>
                        {this.state.submissionData.submissionDownloads.length === 0 ?
                            <Typography variant='body1' color='secondary'>
                                You have no downloads available.
                            </Typography> : null}
                    </CardContent>
                }
            </Card>
        </> : null

    }

    private handleAttestationStepsComplete = (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
        event.preventDefault();
        this.executePlanAction(SubmissionActionTypes.Attestation);
        this.setState({ attestation: { ...this.state.attestation, attestationSigned: true } });

    }


    private handleAttestationStepsCancel = (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
        event.preventDefault();

        this.setState({ attestation: { ...this.state.attestation, attestationStarted: false } });
    }

    private renderCahpsCanMarkFinal = () => {
        return (
            <div>
            <Fab
                disabled={!this.state.isSysAdmin && this.state.submissionData.didValidationError}
                variant="extended"
                color="primary"
                onClick={() => { this.setState({ dialogStatus: { ...this.state.dialogStatus, markFinalOpen: true } }) }}
            >
                Apply Mark Final
            </Fab>
            <Dialog
                open={this.state.dialogStatus.markFinalOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                slots={{ transition: Transition }}
            >
                <DialogTitle id="alert-dialog-title"><Typography className={this.props.classes.primaryBlueSmall}>{this.state.dialogStatus.markFinalTitle}</Typography></DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <Typography className={this.props.classes.secondaryText}>{this.state.dialogStatus.markFinalText}</Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { this.setState({ dialogStatus: { ...this.state.dialogStatus, markFinalOpen: false } }) }} className={this.props.classes.disabledButton} disabled={this.state.isGenericActionHappening}>
                        Cancel
                    </Button>
                    <Button onClick={() => this.executePlanAction(SubmissionActionTypes.MarkFinal)} autoFocus disabled={this.state.isGenericActionHappening}>
                        Continue
                    </Button>
                </DialogActions>
            </Dialog>
            </div>
        );
    }

    private renderUndoPlanLock = () => {
        return (
            <div>
                <Fab
                    variant="extended"
                    color="secondary"
                    onClick={() => { this.setState({ dialogStatus: { ...this.state.dialogStatus, planLockUndoOpen: true } }) }}
                >
                    Undo Plan Lock
                </Fab>
                <Dialog
                    open={this.state.dialogStatus.planLockUndoOpen}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {this.state.dialogStatus.planLockUndoTitle}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {this.state.dialogStatus.planLockUndoText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { this.setState({ dialogStatus: { ...this.state.dialogStatus, planLockUndoOpen: false } }) }} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={async () => {
                            await this.executePlanAction(SubmissionActionTypes.PlanUnlock);
                            this.setState({ dialogStatus: { ...this.state.dialogStatus, planLockUndoOpen: false } });
                        }} color="primary" autoFocus>
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default connect(genericMapStateToProps)(withStyles(idssStyle)(SubmissionHome));
